const USE_MS_ENTRA_KEY = 'useMSEntra'
const DEFAULT_USE_MS_ENTRA = false

export function syncQueryParameters(): void {
  const hash = globalThis.location.hash
  const queryString = hash.includes('?') ? hash.split('?')[1] : globalThis.location.search
  const urlParams = new URLSearchParams(queryString)
  const urlValue = urlParams.get(USE_MS_ENTRA_KEY)

  if (urlValue !== null && urlValue !== undefined) {
    const valueToStore = urlValue.toLowerCase() === 'true' ? 'true' : 'false'
    localStorage.setItem(USE_MS_ENTRA_KEY, valueToStore)
  }
}

export function getUseMSEntraParameter(): boolean {
  const storedValue = localStorage.getItem(USE_MS_ENTRA_KEY)

  if (storedValue === null) {
    const defaultValue = DEFAULT_USE_MS_ENTRA ? 'true' : 'false'
    localStorage.setItem(USE_MS_ENTRA_KEY, defaultValue)
    return DEFAULT_USE_MS_ENTRA
  }

  return storedValue === 'true'
}
